import React from "react";
import "../styles/GoogleForm.css";

const GoogleForm = () => {
  return (
    <div className="google-form-container">
      <div className="responsive-iframe-wrapper">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSd9ABfWPfm6usg3EsQ33klzng3XzefjFkvn50R5yud3dcsNdQ/viewform?embedded=true"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title="Formulario de Google"
          allowFullScreen
        >
          Cargando…
        </iframe>
      </div>
    </div>
  );
};

export default GoogleForm;
